import { render } from "./SVGList.vue?vue&type=template&id=8ac77d74"
import script from "./SVGList.vue?vue&type=script&lang=js"
export * from "./SVGList.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__